import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useLeasingPlans } from './useLeasingPlans';

const useSingleLeasingPlan = () => {
  const { id: routeId } = useParams();
  const { singleItem, loading, handleDownload } = useLeasingPlans(false);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
    handleDownload,
  };
};

export default useSingleLeasingPlan;
